// const routerView = {template: `<router-view/>`}
import auditRouter from './audit'

export const routes = [
    ...auditRouter,
    {
        path: '/',
        name: 'home',
        redirect: '/home'
    },
    {
        path: '/home',
        name: 'home',
        component: () => import('@/views/home/home.vue')
    },
    {
        path: '/apply',
        name: 'apply',
        component: () => import('@/views/apply/apply.vue')
    },
    {
        path: '/apply/select',
        name: 'applySelect',
        component: () => import('@/views/apply/select-type.vue')
    },
    {
        path: '/apply/step-one',
        name: 'applyStepOne',
        component: () => import('@/views/apply/step-one.vue')
    },
    {
        path: '/apply/step-two',
        name: 'applyStepTwo',
        component: () => import('@/views/apply/step-two.vue')
    },
    {
        path: '/apply/confirm-info',
        name: 'applyConfirmInfo',
        component: () => import('@/views/apply/confirm-info.vue')
    },
    {
        path: '/apply/wait-audit',
        name: 'applyWaitReview',
        component: () => import('@/views/apply/wait-audit.vue')
    },
    {
        path: '/apply/finish-enter',
        name: 'applyFinishEnter',
        component: () => import('@/views/apply/finish-enter.vue')
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/login.vue')
    },
    {
        path: '/forget',
        name: 'forget',
        component: () => import('@/views/login/forget.vue')
    },
];
